import { RequireAuth } from '@hobbytools/platform';
import type { RouteObject } from 'react-router';
import { AuthCallback } from './pages/AuthCallback';
import { GroupLayout } from './pages/GroupLayout';
import { GroupMembers } from './pages/GroupMembers';
import { GroupSettings } from './pages/GroupSettings';
import { Home } from './pages/Home';
import { Join } from './pages/Join';
import { Profile } from './pages/Profile';
import { ResetPassword } from './pages/ResetPassword';
import { SignIn } from './pages/SignIn';
import { SignUp } from './pages/SignUp';

export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/sign-in', element: <SignIn /> },
  { path: '/sign-up', element: <SignUp /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  { path: '/reset-password', element: <ResetPassword /> },
  { path: '/join/:code', element: <Join /> },
  {
    path: '/profile',
    element: (
      <RequireAuth>
        <Profile />
      </RequireAuth>
    ),
  },
  {
    path: '/groups/:id',
    element: (
      <RequireAuth>
        <GroupLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <GroupMembers /> },
      { path: 'settings', element: <GroupSettings /> },
    ],
  },
];
